<template lang="html">
  <v-footer app absolute>
    <v-row justify="space-between">
      <v-col cols="12" md="4">
        <router-link tag="div" class="footer-column" to="/kapcsolat">
          <span class="footer--fejlec">Kapcsolat</span>
          <span>Kapcsolattartó</span>
          <span>Telefon,fax</span>
          <span>Email</span>
          <span>Egyéb linkek</span>
        </router-link>
      </v-col>
      <v-col cols="12" md="4">
        <div class="footer-column">
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'HelpInfo'}}" class="footer--fejlec">Támogasson minket!</router-link>
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'HelpInfo'}}">Bankszámlaszám</router-link>
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'HelpInfo'}}">Információk az adományozásról</router-link>
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'Koltsegvetes'}}">Költségvetésünk</router-link>
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'Surgos'}}">Sürgős segítségre van szükségük</router-link>
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'HelpInfo'}}">Nem pénzügyi támogatások</router-link>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="footer-column">
          <span class="footer--fejlec">Védenceink</span>
          <router-link tag="span" :to="{name:'helpus', query:{selectedComp:'Surgos'}}">Sürgős segítségre van szükségük</router-link>
          <router-link tag="span" :to="{name:'orokbefogadas', query:{selectedComp:'ToBeAdopted'}}">Örökbefogadható védenceink</router-link>
          <router-link tag="span" :to="{name:'orokbefogadas', query:{selectedComp:'AlreadyAdopted'}}">Örökbeadott védenceink</router-link>
        </div>
      </v-col>

    </v-row>
  </v-footer>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
footer {
    text-align: center;
    margin-top: 30px;

  &.theme--light.v-footer{
    background: rgb(245,222,179,0.3);
  }


  .footer-column{
    text-decoration: none;
    padding: 0 10px;
    color: rgb(160,82,45);
    font-weight: 500;
    // text-align: left;
    cursor: pointer;

    span, a{
      display: block;

      &:hover{
        color: $darkbrown;
      }
    }
    .footer--fejlec{
      color: $darkbrown;
    }

    @media(max-width:960px){
      text-align: center;
    }

  }
}
</style>
